// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  snapshotId: __t.u64().primaryKey().name("snapshot_id"),
  worldId: __t.u64().name("world_id"),
  seq: __t.u32(),
  kind: __t.string(),
  inverse: __t.string(),
  editor: __t.identity(),
  undone: __t.bool(),
  at: __t.timestamp(),
});
